import { Table } from 'antd';
import React from 'react';

import { PENDING_RELEASE_APPLICATIONS } from './constants';
import { getTableColumns } from './helpers';

export const PendingReleaseTable = () => {
  const columns = getTableColumns();

  return (
    <Table
      bordered
      rowKey="_id"
      scroll={{ x: 'max-content' }}
      columns={columns}
      dataSource={PENDING_RELEASE_APPLICATIONS}
    />
  );
};
